import React from "react";
import { Box, Button, createThemedComponent } from "mineral-ui";
import Link from "../components/Link";
import { H2, P } from "../components/html";

const LoginButton = createThemedComponent(Button, ({ theme }) => ({
  ButtonContent_fontSize: theme.h3_fontSize,
}));

const Login = () => (
  <Box marginHorizontal="auto" marginTop="6em" style={{ maxWidth: "28em" }}>
    <H2 align="center" margin="xl">
      Log in
    </H2>
    <P>&nbsp;</P>
    <P align="center" margin="xl">
      <LoginButton
        element="a"
        primary
        href="/auth/patreon"
        size="jumbo"
        fullWidth
      >
        <span className="fab fa-patreon" /> &nbsp;&nbsp; Log in with Patreon
      </LoginButton>
    </P>
    <P align="center" margin="xl">
      <LoginButton
        element="a"
        primary
        href="/auth/github-sponsors"
        size="jumbo"
        fullWidth
      >
        <span className="fab fa-github" /> &nbsp;&nbsp; Log in with GitHub
        Sponsors
      </LoginButton>
      <small>
        Requests user/organization access to determine sponsor tier.
      </small>
    </P>
    <P align="center" margin="xl">
      <LoginButton element="a" href="/auth/github" size="jumbo" fullWidth>
        <span className="fab fa-github" /> &nbsp;&nbsp; Log in with GitHub
      </LoginButton>
      <small>Minimal permissions, suitable for card payments.</small>
    </P>
    <P>&nbsp;</P>
    <P small>
      Logging in with GitHub or Patreon will create a linked Graphile Store
      account if one doesn't already exist.
    </P>
    <P small>
      Please be sure to review our{" "}
      <Link href="/terms">Terms and Conditions</Link> and{" "}
      <Link href="/privacy">Privacy and Cookies Policy</Link>.
    </P>
  </Box>
);

export default Login;
